import { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { DeleteAccountModal } from './DeleteAccountModal';
import { PrivacyPolicyView } from './PrivacyPolicyView';
import { TermsOfServiceView } from './TermsOfServiceView';

export function DangerZoneCard() {
  const { t } = useTranslation();
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);

  return (
    <>
      <div className="bg-white rounded-[2.5rem] p-2 shadow-[0_8px_40px_rgba(0,0,0,0.04)] border border-stone-100 flex flex-col">
        <ActionRow label={t('danger.privacy')} onClick={() => setPrivacyOpen(true)} />
        <ActionRow label={t('danger.terms')} onClick={() => setTermsOpen(true)} />
        <button
          onClick={() => setDeleteOpen(true)}
          className="flex items-center justify-between p-5 px-6 hover:bg-rose-50 transition-colors text-left rounded-3xl group active:scale-[0.98]"
        >
          <span className="text-[15px] font-bold text-rose-500 group-hover:text-rose-600 transition-colors tracking-tight">{t('danger.deleteAccount')}</span>
        </button>
      </div>
      <DeleteAccountModal open={deleteOpen} onClose={() => setDeleteOpen(false)} />
      <PrivacyPolicyView open={privacyOpen} onClose={() => setPrivacyOpen(false)} />
      <TermsOfServiceView open={termsOpen} onClose={() => setTermsOpen(false)} />
    </>
  );
}

function ActionRow({ label, onClick }: { label: string; onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className="flex items-center justify-between p-5 px-6 hover:bg-stone-50 transition-colors text-left border-b border-stone-50 rounded-3xl active:scale-[0.98]"
    >
      <span className="text-[15px] font-bold text-stone-700 tracking-tight">{label}</span>
      <ChevronRight className="w-4 h-4 text-stone-400" strokeWidth={3} />
    </button>
  );
}
